import img1 from "../assets/images/services/1.webp";
import img2 from "../assets/images/services/2.webp";
import img3 from "../assets/images/services/3.webp";
import img4 from "../assets/images/services/4.webp";
import img5 from "../assets/images/services/5.webp";
import img6 from "../assets/images/services/6.webp";
import img7 from "../assets/images/services/7.webp";
import img8 from "../assets/images/services/8.webp";
import img9 from "../assets/images/services/9.webp";
import img10 from "../assets/images/services/10.webp";
import img11 from "../assets/images/services/11.webp";
import img12 from "../assets/images/services/12.webp";
import img13 from "../assets/images/services/13.webp";
import img14 from "../assets/images/services/14.webp";
import img15 from "../assets/images/services/15.webp";
import img16 from "../assets/images/services/16.webp";
import img17 from "../assets/images/services/17.webp";

export const serviceImageMap: Record<string, string> = {
  "services/1.png": img1,
  "services/2.png": img2,
  "services/3.png": img3,
  "services/4.png": img4,
  "services/5.png": img5,
  "services/6.png": img6,
  "services/7.png": img7,
  "services/8.png": img8,
  "services/9.png": img9,
  "services/10.png": img10,
  "services/11.png": img11,
  "services/12.png": img12,
  "services/13.png": img13,
  "services/14.png": img14,
  "services/15.png": img15,
  "services/16.png": img16,
  "services/17.png": img17,
};

// Held so the browser keeps the decoded bitmaps around for instant slide swaps.
const preloadedImages: HTMLImageElement[] = [];

export function preloadServiceImages() {
  if (preloadedImages.length > 0) return;

  for (const src of Object.values(serviceImageMap)) {
    const img = new Image();
    img.decoding = "async";
    img.src = src;
    img.decode().catch(() => {});
    preloadedImages.push(img);
  }
}
